export default __webpack_public_path__ + "static/media/vid.119515df.mp4";